import { render, staticRenderFns } from "./FooterCat.vue?vue&type=template&id=07575383&scoped=true&"
import script from "./FooterCat.vue?vue&type=script&lang=js&"
export * from "./FooterCat.vue?vue&type=script&lang=js&"
import style0 from "./FooterCat.vue?vue&type=style&index=0&id=07575383&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07575383",
  null
  
)

export default component.exports